import React, { useEffect, useState } from "react";
import { Grid, Box, Button, FormControl, InputLabel, Select, MenuItem, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import TablePL from "./TablePL";
import TableBSMonthly from "./TableBS_Monthly";
import TableBSAnnual from "./TableBS_Annual";
import { getFinancialReport } from "services/financialdata";
import { Loading } from "react-admin";
import { getDeptCodeListWithSp } from "services/callStoreProcedure";
import { useTranslate } from "react-admin";
import PLIcon from "assets/profit-and-loss.png";
import BSIcon from "assets/balance-sheet.png";
import PLWIcon from "assets/profit-and-loss-w.png";
import BSWIcon from "assets/balance-sheet-w.png";
import { callStoreReport } from "services/callStoreProcedure";
import DialogDepartment from "./DialogDepartment";

const useStyles = makeStyles((theme) => ({
  button: { textTransform: "none" },
}));

const List = (props) => {
  const classes = useStyles();
  const { lookupData, basePath, permissions } = props;
  const translate = useTranslate();
  const [isLoading, setLoading] = useState(false);
  const ws = window.sessionStorage;
  const t = localStorage.getItem("Tenant");
  const [selectedReport, setSelectedReport] = useState(ws.getItem(`${t}_selectedReport`) ?? "BS");
  const [reportData, setReportData] = useState([]);
  const [titleHead, setTitleHead] = useState("Balance Sheet");
  const [lookupDept, setLookupDept] = useState();
  const [periodStart, setPeriodStart] = useState();
  const [period, setPeriod] = useState({
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
  });
  const [periodList, setPeriodList] = useState([]);
  const [revision, setRevision] = useState(0);
  const [reportType, setReportType] = useState(1);
  const [openDialogDept, setOpenDialogDept] = useState(false);
  const [department, setDepartment] = useState();
  const [view, setView] = useState(false);
  const [parameters, setParameters] = useState({
    Year: period.year, //year
    Period: period.month, //month
    BudgetRevision: revision, //revision
    Departments: [], //department
  });

  const fetchDept = async () => {
    const deptList = await getDeptCodeListWithSp();
    const newDeptLookUp = deptList.map((el, idx) => {
      return Object.assign(
        {},
        {
          id: idx,
          value: el.DeptCode,
          label: el.DeptFullName,
        }
      );
    });
    setLookupDept(newDeptLookUp);
    setDepartment(newDeptLookUp.map((i) => i.value));
  };

  const fetchPeriodList = async () => {
    const response = await callStoreReport("rptGetListGlPeriod", {});
    setPeriodStart(response[0]);
    setPeriodList(response);
  };

  const fetchData = async (type) => {
    setLoading(true);
    const getIdReport = lookupData.find((i) => i.Code === type)?.Code;
    try {
      switch (type) {
        case "PL":
          let paramPL = {
            ReportId: getIdReport,
            Year: period.year,
            Period: period.month,
            BudgetRevision: revision,
            Departments: [],
          };

          if (department) {
            paramPL.Departments = department;
          }

          const plData = await getFinancialReport(paramPL);
          if (plData?.Code < 0) {
            setReportData([]);
          } else {
            setReportData(plData);
          }
          setLoading(false);
          break;
        case "BS":
          let paramBS = {
            ReportId: getIdReport,
            ReportType: reportType,
            Year: period.year,
            Period: period.month,
            Departments: [],
          };

          if (department) {
            paramBS.Departments = department;
          }

          const bsData = await getFinancialReport(paramBS);
          if (bsData?.Code < 0) {
            setReportData([]);
          } else {
            setReportData(bsData);
          }
          setLoading(false);
          break;
        default:
          setLoading(false);
          break;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchDept();
    fetchPeriodList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleButtonClick = (buttonName) => {
    if (buttonName === "PL") {
      setTitleHead("Profits and Loss");
      setReportData([]);
      //fetchData("PL");
    }
    if (buttonName === "BS") {
      setTitleHead("Balance Sheet");
      setReportData([]);
      //fetchData("BS");
    }
    const ws = window.sessionStorage;
    const t = localStorage.getItem("Tenant");
    ws.setItem(`${t}_selectedReport`, buttonName);
    setSelectedReport(buttonName);
  };

  if (isLoading) return <Loading />;

  return (
    <>
      <Box height={10} />
      {!selectedReport ? (
        <div style={{ width: "100%", margin: "0 auto" }}>
          <Grid container justifyContent="flex-end" direction="row-reverse">
            {lookupData &&
              lookupData.map((item, idx) => (
                <Button
                  key={idx}
                  className={classes.button}
                  style={{ marginRight: 10 }}
                  variant="outlined"
                  //classes={{ root: classes.button, label: classes.label }}
                  onClick={() => handleButtonClick(`${item.Code}`)}
                >
                  <img style={{ height: 38, padding: 8 }} src={idx === 0 ? PLIcon : BSIcon} alt="" />
                  {item.Name}
                </Button>
              ))}
          </Grid>
        </div>
      ) : (
        <>
          <Grid container justifyContent="flex-end" direction="row-reverse">
            {lookupData &&
              lookupData.map((item, idx) => (
                <Button
                  key={idx}
                  className={classes.button}
                  style={{ marginRight: 10 }}
                  variant={selectedReport === item.Code ? "contained" : "outlined"}
                  color="primary"
                  onClick={() => handleButtonClick(`${item.Code}`)}
                >
                  <img
                    style={{ height: 38, padding: 8 }}
                    src={
                      idx === 0
                        ? selectedReport === item.Code
                          ? PLWIcon
                          : PLIcon
                        : selectedReport === item.Code
                        ? BSWIcon
                        : BSIcon
                    }
                    alt=""
                  />

                  {item.Name}
                </Button>
              ))}
          </Grid>

          <Grid container>
            <Grid item>
              {selectedReport && (
                <Box style={{ marginTop: 10 }} display={"flex"} alignItems={"center"} justifyContent={"flex-end"}>
                  {/* <>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isAllDepartment}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setDepartment(lookupDept);
                          } else {
                            setDepartment([]);
                          }
                          setIsAllDepartment(e.target.checked);
                        }}
                        name="All Department"
                      />
                    }
                    label="All Department"
                  />
                  {lookupDept && (
                    <Autocomplete
                      multiple
                      limitTags={6}
                      options={lookupDept}
                      disableCloseOnSelect
                      disableListWrap
                      value={department}
                      onChange={(e, newValue) => {
                        if (newValue.length !== lookupDept.length) {
                          setIsAllDepartment(false);
                        }
                        setDepartment(newValue);
                        // let allObj = newValue.find((i) => i.Id === 0);
                        // if (!allObj) {
                        //   setDepartment(newValue);
                        // } else {
                        //   newValue.filter((i) => i.Id !== 0);
                        //   setDepartment(newValue);
                        //}
                      }}
                      // classes={{
                      //   inputRoot: classes.inputRoot,
                      //   option: classes.option,
                      // }}
                      style={{
                        width: 400,
                        display: "inline-flex",
                        marginRight: 20,
                      }}
                      getOptionLabel={(option) => option.DeptCode}
                      renderOption={(option, { selected }) => (
                        <React.Fragment>
                          <Checkbox
                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.DeptCode} : {option.Description}
                        </React.Fragment>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label="Department"
                          margin="dense"
                          placeholder="Department"
                        />
                      )}
                    />
                  )}
                </> */}

                  <>
                    <Button
                      className={classes.button}
                      variant="contained"
                      color="primary"
                      style={{ marginRight: 10 }}
                      onClick={() => {
                        setOpenDialogDept(!openDialogDept);
                      }}
                    >
                      Select Department
                    </Button>
                    {openDialogDept && (
                      <DialogDepartment
                        open={openDialogDept}
                        onClose={() => setOpenDialogDept(false)}
                        department={department}
                        setDepartment={setDepartment}
                        lookupDept={lookupDept}
                      />
                    )}
                  </>
                  {periodStart && (
                    <Autocomplete
                      style={{ width: 210, display: "inline-flex" }}
                      label="Select Period"
                      name="periodStart"
                      disableClearable
                      options={periodList}
                      getOptionLabel={(option) => option?.PeriodEndDate ?? ""}
                      renderInput={(params) => (
                        <TextField {...params} label="Select Period" variant="outlined" margin="dense" fullWidth />
                      )}
                      value={periodStart}
                      onChange={(e, newValue) => {
                        setPeriodStart(newValue);
                        setPeriod({
                          year: newValue?.GlYear,
                          month: newValue?.GlpNo,
                        });
                      }}
                    />
                  )}

                  {selectedReport === "PL" && (
                    <FormControl variant="outlined" margin="dense" fullWidth style={{ width: 210, marginLeft: 10 }}>
                      <InputLabel id="size-select">Select Budget (Revision)</InputLabel>
                      <Select
                        labelId="size-select"
                        value={revision}
                        onChange={(e) => {
                          setRevision(e.target.value);
                        }}
                        label="Select Budget (Revision)"
                        style={{
                          width: 210,
                          padding: 2,
                        }}
                      >
                        {[
                          { id: 0, name: "Annual" },
                          { id: 1, name: "Reivision 1" },
                          { id: 2, name: "Reivision 2" },
                          { id: 3, name: "Reivision 3" },
                          { id: 4, name: "Reivision 4" },
                        ].map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}

                  {selectedReport === "BS" && (
                    <FormControl variant="outlined" margin="dense" fullWidth style={{ width: 210, marginLeft: 10 }}>
                      <InputLabel id="viewMode">{translate("ra.field.ViewBy")}</InputLabel>
                      <Select
                        labelId="viewMode"
                        label={translate("ra.field.ViewBy")}
                        value={reportType}
                        onChange={(e) => {
                          setReportType(e.target.value);
                        }}
                        style={{
                          width: 210,
                          padding: 2,
                        }}
                      >
                        {[
                          { id: 1, name: "Monthly" },
                          { id: 2, name: "Annual" },
                        ].map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                  <Button
                    className={classes.button}
                    style={{ marginLeft: 10 }}
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      setView(true);
                      setParameters({
                        Year: period.year,
                        Period: period.month,
                        BudgetRevision: revision,
                        Departments: department,
                      });
                      fetchData(selectedReport);
                    }}
                  >
                    View
                  </Button>
                </Box>
              )}
            </Grid>
          </Grid>
        </>
      )}

      <Box height={14} />
      {selectedReport === "PL" && (
        <TablePL
          basePath={basePath}
          translate={translate}
          dataTable={view ? reportData : []}
          title={titleHead}
          permissions={permissions}
          parameters={parameters}
        />
      )}
      {selectedReport === "BS" && reportType === 1 && (
        <TableBSMonthly
          basePath={basePath}
          dataTable={view ? reportData : []}
          title={titleHead}
          permissions={permissions}
          parameters={parameters}
        />
      )}
      {selectedReport === "BS" && reportType === 2 && (
        <TableBSAnnual
          basePath={basePath}
          dataTable={view ? reportData : []}
          title={titleHead}
          permissions={permissions}
          parameters={parameters}
        />
      )}
    </>
  );
};

export default List;
